import { buildActivityLogDetailRows } from "./activityLogDetail";

export const MCO_ACTIVITY_STEPS = [
  {
    id: 1,
    label: "Document Submission",
    slaDays: 1,
    aliases: ["Documents Uploading", "Application Submitted"],
  },
  {
    id: 2,
    label: "Document Verification",
    slaDays: 1,
    aliases: ["Documents Verification"],
  },
  { id: 3, label: "Approval / Rejection", slaDays: 1 },
  {
    id: 4,
    label: "Arrear Verification",
    slaDays: 1,
    aliases: ["Arrears Verification"],
  },
  {
    id: 5,
    label: "Field Survey & Cost Estimation",
    slaDays: 1,
    aliases: ["Field Survey"],
  },
  { id: 6, label: "M&T Report", slaDays: 5 },
  { id: 7, label: "DN Approval", slaDays: 1 },
  { id: 8, label: "DN Submission", slaDays: 30 },
  { id: 9, label: "DN Payment Verification", slaDays: 1 },
  { id: 10, label: "Meter Installation", slaDays: 1 },
  {
    id: 11,
    label: "Forward to RO",
    slaDays: 1,
    aliases: ["Forward To RO"],
  },
  { id: 12, label: "Ready for Billing", slaDays: 1 },
];

export function buildMcoActivityLogDetailRows(
  historyItems = [],
  currentStatus = {},
  formatDateFn,
) {
  return buildActivityLogDetailRows(historyItems, currentStatus, formatDateFn, {
    steps: MCO_ACTIVITY_STEPS,
    stepNameField: "mcoProgStatusName",
    totalExcludeStepLabels: ["DN Submission"],
  });
}
